<p class="mb-0 pagination-title text-right" *ngIf="showTitle">{{showPaginationTitle()}}</p>
<ngb-pagination 
    [(page)]="pageNumber" (pageChange)="changePage($event)"
    [pageSize]="pageSize" [collectionSize]="totalData" [boundaryLinks]="false" [maxSize]="2" [rotate]="true" [ellipses]="true"
    aria-label="Default pagination" class="pagination-rounded d-flex justify-content-end">
</ngb-pagination>